"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.flags = exports.FeatureFlags = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/entries"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url-search-params"));

var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var FeatureFlags = /*#__PURE__*/function () {
  function FeatureFlags(location) {
    (0, _classCallCheck2.default)(this, FeatureFlags);
    this._flagServices = void 0;
    this._flagSettings = new _map2.default();
    this._flights = void 0;
    this._flags = {};
    this._showFlags = void 0;
    this._flagServices = [];

    if (location !== undefined) {
      try {
        var searchParams = new _urlSearchParams.default(location.search);
        var showFlags = searchParams.get('flags');

        if (showFlags !== null) {
          this._showFlags = showFlags === 'true';
        }
      } catch (err) {// Ignore errors on dev flag
      }
    }
  }

  (0, _createClass2.default)(FeatureFlags, [{
    key: "addFlagService",
    value: function addFlagService(service) {
      this._flagServices.push(service);
    }
    /**
     * Registers properties from a settings object as known configuration settings
     * @param settings The mapping between a flag (used in JavaScript) and its api feature name
     */

  }, {
    key: "registerFlags",
    value: function registerFlags(settings) {
      var _context,
          _this = this;

      (0, _forEach.default)(_context = (0, _keys.default)(settings)).call(_context, function (key) {
        _this._flagSettings.set(key, settings[key]);

        _this._flags[key] = false;
      });
    }
    /**
     * Gets the config based on known configuration flags where the flag is true if there is a flight with the same name as the setting
     */

  }, {
    key: "get",
    value: function get() {
      if (this._flights === undefined) {
        var flights = new _set.default();

        if (this._showFlags !== undefined) {
          var _iterator = (0, _createForOfIteratorHelper2.default)(this._flagServices),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var flagService = _step.value;
              flagService.saveOverride('show-flags', this._showFlags);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        var _iterator2 = (0, _createForOfIteratorHelper2.default)(this._flagServices),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _flagService = _step2.value;

            var cachedFlags = _flagService.getCachedFlags();

            if (cachedFlags) {
              for (var _i2 = 0, _Array$from3 = (0, _from.default)((0, _entries.default)(cachedFlags).call(cachedFlags)); _i2 < _Array$from3.length; _i2++) {
                var _Array$from3$_i = (0, _slicedToArray2.default)(_Array$from3[_i2], 1),
                    _flightName = _Array$from3$_i[0];

                flights.add(_flightName);
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (flights !== undefined && flights.size > 0) {
          for (var _i = 0, _Array$from = (0, _from.default)((0, _entries.default)(_context2 = this._flagSettings).call(_context2)); _i < _Array$from.length; _i++) {
            var _context2;

            var _Array$from$_i = (0, _slicedToArray2.default)(_Array$from[_i], 2),
                flightName = _Array$from$_i[0],
                _key = _Array$from$_i[1];

            this._flags[flightName] = flights.has(_key);
          }

          this._flights = flights;
        }
      }

      return this._flags;
    }
  }, {
    key: "saveOverride",
    value: function saveOverride(flagName, enabled) {
      var flightName = this._flagSettings.get(flagName);

      if (flightName !== undefined) {
        // Reset the flights cache
        this._flights = undefined;

        var _iterator3 = (0, _createForOfIteratorHelper2.default)(this._flagServices),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var flagService = _step3.value;
            flagService.saveOverride(flightName, enabled);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "setFlag",
    value: function setFlag(flagName, enabled) {
      var name = flagName;
      this._flags[name] = enabled;
    }
  }, {
    key: "getFlags",
    value: function getFlags() {
      var _context3,
          _this2 = this;

      return _promise.default.all((0, _map.default)(_context3 = this._flagServices).call(_context3, function (flagService) {
        return flagService.getFlags();
      })).then(function () {
        return _this2.get();
      });
    }
  }, {
    key: "resetOverrides",
    value: function resetOverrides() {
      // Reset the flights cache
      this._flights = undefined;

      var _iterator4 = (0, _createForOfIteratorHelper2.default)(this._flagServices),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var flagService = _step4.value;
          flagService.resetOverrides();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }]);
  return FeatureFlags;
}();

exports.FeatureFlags = FeatureFlags;
var flags = new FeatureFlags(window.location);
exports.flags = flags;